import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b243c6d&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthFormAuth: require('/home/bitrix/lka/frontend/components/auth/formAuth.vue').default,AuthInformAuth: require('/home/bitrix/lka/frontend/components/auth/informAuth.vue').default})
